var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3575 6.75185C33.4349 5.00785 30.5655 5.00785 29.6429 6.75185L5.64288 52.0852C5.42684 52.4915 5.31973 52.9469 5.332 53.4069C5.34427 53.8669 5.4755 54.3159 5.71289 54.7101C5.95029 55.1044 6.28575 55.4304 6.68661 55.6564C7.08746 55.8824 7.54003 56.0007 8.00022 55.9998H56.0002C56.4601 56.0008 56.9124 55.8826 57.3129 55.6567C57.7135 55.4308 58.0487 55.105 58.2859 54.711C58.523 54.317 58.6541 53.8682 58.6661 53.4085C58.6782 52.9488 58.571 52.4938 58.3549 52.0879L34.3575 6.75185ZM34.6669 47.9998H29.3335V42.6665H34.6669V47.9998ZM29.3335 37.3332V23.9998H34.6669L34.6696 37.3332H29.3335Z",
    fill: "#4974D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgIconWarning);
export default __webpack_public_path__ + "static/media/img-icon-warning.e743dceafc57a1e09d6e6362b59f999a.svg";
export { ForwardRef as ReactComponent };